import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '../../../utils/baseQueryWithReauth';

export const tutorAvailabilityApi = createApi({
  reducerPath: 'tutorAvailabilityApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getAllAvailability: builder.query({
      query: () => ({
        url: "/WebTutor/GetAllAvailability",
        method: "Get",
      }),
    }),
    updateAllAvailability: builder.mutation({
      query: (payload) => ({
        url: "/WebTutor/WeeklyAvailability",
        method: "Post",
        body: payload
      }),
    }),
    getDateSpecificAvailability: builder.query({
      query: ({Date}) => ({
        url: "/WebTutor/GetDateSpecificAvailability",
        method: "Get",
        params: ({Date})
      }),
    }),
    updateDateSpecificAvailability: builder.mutation({
      query: (payload) => ({
        url: "/WebTutor/DateSpecificAvailability",
        method: "Post",
        body: payload
      }),
    }),
  }),
});

export const { 
  useGetAllAvailabilityQuery,
  useUpdateAllAvailabilityMutation,
  useGetDateSpecificAvailabilityQuery,
  useUpdateDateSpecificAvailabilityMutation
} = tutorAvailabilityApi;